import * as React from "react";
import { forwardRef } from "react";
const SvgAsc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 6, viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.0594443 5.10688C0.184444 5.40688 0.474444 5.60187 0.799444 5.60187H8.79945C9.12195 5.60187 9.41445 5.40688 9.53945 5.10688C9.66445 4.80688 9.59445 4.46438 9.36695 4.23438L5.36695 0.234375C5.05445 -0.078125 4.54695 -0.078125 4.23445 0.234375L0.234444 4.23438C0.00444433 4.46438 -0.0630555 4.80688 0.0619445 5.10688H0.0594443Z", fill: "#61676C" }));
const ForwardRef = forwardRef(SvgAsc);
export default ForwardRef;
